module.exports = __webpack_public_path__ + "img/jp.ddb5ebbe.png";